<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <h1>{{ 'STRATEGY.'+impact+'.modal.title' | translate }}</h1>
  <h2>{{ 'STRATEGY.'+impact+'.modal.smalltitle' | translate }}</h2>
  <p [innerHtml]="'STRATEGY.'+impact+'.modal.p' | translate"></p>
  <ion-button mode="ios" (click)="openLearnMore()">{{'STRATEGY.exclusion.modal.cta' | translate}}</ion-button>
</ion-content>
